"use client";

import { useContext, forwardRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { borderRadius, getAppearanceConstant, backgroundColorLevel1 } from "@churchofjesuschrist/eden-style-constants";
import { sharedCheckCss, darkModeURLIcon } from "../utils/sharedCss";
import { AppearanceContext } from "@churchofjesuschrist/eden-appearance";
import { jsx as _jsx } from "react/jsx-runtime";
export const InternalUseOnlyCheckbox = styled.input.attrs({
  type: "checkbox"
}).withConfig({
  componentId: "sc-csv0c-0"
})(["", ";border-radius:", ";&:checked{background-image:", ";}&:indeterminate{background-image:", ";}"], sharedCheckCss, borderRadius, _ref => {
  let {
    $curAppearanceContext
  } = _ref;
  return darkModeURLIcon(`<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5.96169 12.6554C5.91615 12.6845 5.87238 12.7178 5.83088 12.7552C5.42045 13.1247 5.38731 13.757 5.75686 14.1674L8.55657 17.2768C8.62209 17.3496 8.69587 17.4105 8.7752 17.4594C9.15526 17.6981 9.66273 17.6575 10.0005 17.3321L18.1391 9.5C18.5368 9.11678 18.5485 8.48373 18.1653 8.08603C17.7821 7.68833 17.149 7.6766 16.7513 8.05981L9.35598 15.1757L7.24315 12.8292C7.07017 12.6371 6.83961 12.5276 6.60119 12.5034C6.57514 12.4977 6.54869 12.4933 6.52193 12.4903C6.32297 12.4682 6.12336 12.526 5.967 12.651C5.96522 12.6525 5.96345 12.6539 5.96169 12.6554Z" /></svg>`, getAppearanceConstant(backgroundColorLevel1), $curAppearanceContext);
}, _ref2 => {
  let {
    $curAppearanceContext
  } = _ref2;
  return darkModeURLIcon(`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H8Z" fill="white"/></svg>`, getAppearanceConstant(backgroundColorLevel1), $curAppearanceContext);
});

/**
 * Checkboxes can be used when several answers or no answer at all can correctly apply to a question. They can also be used when there is a list of settings that can be enabled or disabled.
 */
const Checkbox = /*#__PURE__*/forwardRef((props, ref) => {
  const curAppearanceContext = useContext(AppearanceContext);
  return /*#__PURE__*/_jsx(InternalUseOnlyCheckbox, {
    ref: ref,
    ...props,
    $curAppearanceContext: curAppearanceContext
  });
});
Checkbox.displayName = "Checkbox";
Checkbox.propTypes = {
  /** The checked state for controlled use. */
  checked: PropTypes.bool,
  /** Default checked state for uncontrolled use */
  defaultChecked: PropTypes.bool,
  /** Makes the input not mutable, focusable, or even submitted with the form */
  disabled: PropTypes.bool,
  /** Used to reference elements in JavaScript, or to reference form data after a form is submitted */
  name: PropTypes.string,
  /** Callback to execute when the Checkbox is toggled */
  onChange: PropTypes.func,
  /** Whether the input is required to be filled out to validate */
  required: PropTypes.bool,
  /** Value of the Checkbox */
  value: PropTypes.string
};
export default Checkbox;